const Price = ({ valuation }: { valuation: number }) => {
  return (
    <div className="price-box">
      <p className="price-p">Success! Your offer is</p>
      <h2 className="estimate-price">
        £{valuation && valuation.toLocaleString()}*
      </h2>
    </div>
  );
};

export { Price };
